<template>
  <div>
    <p class="tisp_title">{{ $t("lang.数据统计仅保留近一年内的记录") }}</p>
    <el-table :data="tableData" height="675" v-if="deviceType == 0">
      <el-table-column
        v-for="item in recordLabel"
        :key="item.prop"
        :label="
          item.prop == 'amount'
            ? `${$t('lang.' + item.label)}(${monetary})`
            : $t('lang.' + item.label)
        "
        :prop="item.prop"
        :width="item.width"
        align="center"
        :formatter="formatter"
      >
      </el-table-column>
      <el-table-column
        :label="$t('lang.操作')"
        :width="$i18n.locale == 'zh-CN' ? '100' : '150'"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table_operation">
            <el-button type="text" @click="onClickReceipt(scope.row)">
              {{ $t("lang.查看回执单") }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="tableData" height="675" v-else-if="deviceType == 1">
      <el-table-column
        v-for="item in waterRecordLabel"
        :key="item.prop"
        :label="
          item.prop == 'amount'
            ? `${$t('lang.' + item.label)}(${monetary})`
            : $t('lang.' + item.label)
        "
        :prop="item.prop"
        :width="item.width"
        align="center"
        :formatter="formatter"
      >
      </el-table-column>
      <el-table-column
        :label="$t('lang.操作')"
        :width="$i18n.locale == 'zh-CN' ? '100' : '150'"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table_operation">
            <el-button type="text" @click="onClickReceipt(scope.row)">
              {{ $t("lang.查看回执单") }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 代客充值 -->
    <RechargeDialog ref="rechargeDialogRef" />
    <!-- 水表代客充值 -->
    <WaterRechargeDialog ref="waterRechargeDialogRef" />
  </div>
</template>

<script>
import { recordLabel } from "../../define.js";
import { mapActions } from "vuex";
import {waterRecordLabel} from "../../define";
import WaterRechargeDialog from "../../dialog/water-recharge-dialog";
import RechargeDialog from "../../dialog/recharge-dialog";
export default {
  components: {
    recordLabel,
    WaterRechargeDialog,
    RechargeDialog
  },
  data() {
    return {
      recordLabel: recordLabel,
      waterRecordLabel: waterRecordLabel,
      tableData: [],
      deviceType: 0,
      monetary: "元",
      rechargeData:{
        deviceName: "",
        nickName: "",
        remainKwh: "",
        priceValue: "",
        phone: "",
        pointId: "",
        token: "",
        orderNo: "",
        rechargeType: -1,
        tagNo: "",
        createTime: "",
      },

    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      rechargeRecord: "ZD_RechargeRecord",
      waterRechargeRecord: "ZD_WaterRechargeRecord",
    }),
    onClickReceipt(row){
      this.rechargeData.token = row.token;
      this.rechargeData.orderNo = row.tradeNo;
      this.rechargeData.priceValue = row.amount;
      this.rechargeData.price = row.price;
      this.rechargeData.tagNo = row.tagNo
      this.rechargeData.createTime = row.createTime
      this.rechargeData.rechargeType = 2;
      /**代客充值 */
      switch (this.deviceType) {
        case 0:
          this.rechargeData.remain = row.kwh;
          this.$refs.rechargeDialogRef.showDialog(this.rechargeData);
          break;
        case 1:
          this.rechargeData.remain = row.water;
          this.$refs.waterRechargeDialogRef.showDialog(this.rechargeData);
          break;
        default:
          break;
      }
    },
    async getRechargeRecord(pointId, deviceType, nickName, phone, deviceName) {
      this.deviceType = deviceType
      this.rechargeData.pointId = pointId
      this.rechargeData.nickName = nickName
      this.rechargeData.phone = phone
      this.rechargeData.deviceName = deviceName
        let res = {};
      this.monetary = localStorage.getItem("monetary");
      switch (this.deviceType) {
        case 0:
          res = await this.rechargeRecord({ pointId: pointId });
          if (res.success !== 1) return;
          this.tableData = res.listitem;
          break;
        case 1:
          res = await this.waterRechargeRecord({ pointId: pointId });
          if (res.success !== 1) return;
          this.tableData = res.listitem;
          break;
        default:
          break
      }

    },
    formatter(row, { property }) {
      if (property == "project"){
        let res = "";
        switch (this.deviceType) {
          case 0:
            res = this.$t("lang.剩余电量2")
            break;
          case 1:
            res = this.$t("lang.剩余水量2")
            break;
          default:
            break
        }
        return res;
      }
      if (property == "people") return this.$t("lang.业主");
      if (property == "amount" || property == "kwh" || property == "water") {
        return Number(row[property]).toFixed(2);
      }
      return row[property];
    },
  },
};
</script>

<style scoped lang='less'>
.tisp_title {
  font-size: 12px;
  color: #999;
}
.table_operation {
  span {
    color: #409eff;
    margin: 0 5px;
  }
}
</style>
